import {
  Component, Input, OnInit, Output, EventEmitter,
  HostListener, AfterViewInit, ViewChild,
  ChangeDetectionStrategy, ChangeDetectorRef, OnChanges, SimpleChanges, TemplateRef, Type, ElementRef, Renderer2, ViewChildren, QueryList, ViewEncapsulation,
  LOCALE_ID,
  Inject
} from '@angular/core';
import { Table, TableModule } from 'primeng/table';
import { PutJsonObjectService } from '../services/put-json-object.service';
import { GetJsonObjectService } from '../services/get-json-object.service';
import { PostJsonObjectService } from '../services/post-json-object.service';
import { first } from 'rxjs/operators';
import { AlertService } from '../services/alert.service';
import { HashTable, tools } from '../services/tools';
import { SharedMenuService } from '../services/shared-menu.service';
import * as lodhash from 'lodash';
import moment from 'moment';
import { OverlayService } from '../services/overlay/overlay.service'
import { DomSanitizer } from '@angular/platform-browser';
import { PrimeNgArrayD4Service } from './prime-ng-array-d4.service';
import { ModalTextAreaForArrayComponent } from './modal-text-area-for-array/modal-text-area-for-array.component';
import { SearchCountryField, CountryISO, PhoneNumberFormat, NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { environment } from '../../../environments/environment';
import { EntitySummaryOverlayContainerComponent } from '../entity-summary/entity-summary-overlay-container/entity-summary-overlay-container.component';
import { MaterialModule } from '../../material-module';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { SafePipe } from '../services/safe.pipe';
import { ClipboardModule } from 'ngx-clipboard';
import { LogService } from '../log-service.service';
import { PrimgNgArrayD4ExternalComponentService } from './primg-ng-array-d4-external-component.service';
import { DragDropModule } from 'primeng/dragdrop';


/*
  input 
    - objectList : rowsObject as JSON array
    - columnsDefinition : array of columnDefinition (for ngStyle see https://angular.io/api/common/NgStyle)
    - nullArrayDisplayText : text display in case of empty objectList
    - filterFields : list of columns to be filtered, only for local filter
    - apiUrl : if apiUrl != null, PrimeNgArrayD4Component will send and update data using apiUrl road.
               if apiUrl == null || '' PrimeNgArrayD4Component will emit object when modified
  output 
    - editionOutput : see apiUrl == null || '' above
    // - sidenavEdit : emitEvent when user click on any icon in array (could be pencil,view or outputMethod declare in definition)
*/

/*
WARING : ChangeDetection is set to Onpush => html actialisation is only set on user Action, must be call manually
*/

@Component({
  selector: 'app-prime-ng-array-d4',
  templateUrl: './prime-ng-array-d4.component.html',
  styleUrls: ['./prime-ng-array-d4.component.scss'],
  imports: [
    TableModule,
    MaterialModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    SafePipe,
    ClipboardModule,
    NgxIntlTelInputModule,
    DragDropModule
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class PrimeNgArrayD4Component implements OnInit, AfterViewInit, OnChanges {
  preferredCountries: CountryISO[];
  searchCountryField: typeof SearchCountryField;
  countryISO: typeof CountryISO;
  phoneNumberFormat: typeof PhoneNumberFormat;



  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: any) {
    this.keyDownEventManager(event);
  }

  @Input() public arrayName: string = '';
  @Input() objectList: any;
  @Input() columnsDefinition: columnDefinition[] = [];
  @Input() nullArrayDisplayText: string = "";
  @Input() filterFields: string[] = []; //for a global fiter using localDatas
  @Input() loading: boolean = true;
  @Input() apiUrl: string = "";
  @Input() allowArrayCustomisation: boolean = true;
  @Input() displayHeader: boolean = true;
  @Input() displayPaginator: boolean = true;
  @Input() objectHelperList?: any = null;
  @Input() apiUrlSend?: string = "";
  @Input() scrollHeight?: number = 0;
  @Input() preSelection?: any[] = [];
  @Input() trNgStyle?: any = "";
  @Input() scrollHeightOffset: number = 0;
  @Input() firstLineEditionBurstEvent: boolean = false;
  @Input() goToBottom: boolean = false;
  @Input() columnResizeMode: "fit" | "expand" = "fit";
  @Input() heightMode: "full" | "variable" = "full"
  @Input() type: string = "" //type of object to be drag

  @Output() public editionOutput: EventEmitter<any> = new EventEmitter<any>();
  @Output() public editionOutputV2: EventEmitter<any> = new EventEmitter<any>();
  @Output() public sidenavEdit: EventEmitter<string> = new EventEmitter<string>();
  @Output() public selection: EventEmitter<any> = new EventEmitter<any>();
  @Output() public rowClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() public itemAction: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('dt') table: Table | undefined;
  @ViewChild('arrayContainer') arrayContainer: ElementRef | undefined;
  @ViewChildren('matSelectForms') matSelectForms!: QueryList<ElementRef>;

  private lastRowsBeforeUpdate: any[] = [];
  private columnsDefinitionRef: any[] = [];

  public primeNgCols: any = [];
  public objectEdited: any;
  public ScrollableHeight: string = "880px";
  public currentPage: number = 1;
  public lastItem: number = 1;
  public numbersPages: number = 1;
  public sortingValuesN1: any[] = [];
  public sortingValuesN2: any[] = [];
  public filterList: any = {};
  public ObjectKeys = Object.keys;
  public toolTipsClass: string = "tool-tip-size-0-9-em";

  public objectListSelection: any[] = [];
  public itemDrag: any;
  public itemDragMvt: boolean = false;
  public dragRowOver: number = -1;
  public frozenCols: any[] = [];
  private pointerInsideArrayDiv: boolean = false;
  private fullWidth: number = -1;
  public arrayGuid: string = "";
  public defaultRows: number = 20;
  public rowsPerPageOptions: any = [20, 50, 100];
  public currentPageReportTemplate = "Éléments par page";
  public styleClass = 'p-datatable-content p-datatable-sm';
  public styleClassPaginator = 'paginator-full-height-array';

  constructor(
    private alertService: AlertService,
    private sharedMenuServices: SharedMenuService,
    private tools: tools,
    public primeNgArrayD4Service: PrimeNgArrayD4Service,
    private sanitizer: DomSanitizer,
    private externalComponentService: PrimgNgArrayD4ExternalComponentService,
    private overlayService: OverlayService,
    private changeDetectorRef: ChangeDetectorRef,
    private getJsonService: GetJsonObjectService,
    @Inject(LOCALE_ID) public locale: string
  ) {
    this.arrayGuid = this.tools.guid(false);
    this.preferredCountries = [CountryISO.France];
    this.searchCountryField = SearchCountryField;
    this.countryISO = CountryISO;
    this.phoneNumberFormat = PhoneNumberFormat;
  }

  ngOnInit(): void {
    this.initialiseDatas();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.changeDetectorRef.detectChanges();
    if (changes['firstLineEditionBurstEvent'] != null) {
      let eventCode = { code: "F2" };
      this.keyDownEventManager(eventCode, true);
      this.firstLineEditionBurstEvent = false;
    }
    if (changes['scrollHeight'] != null) {
      if (this.scrollHeight != null && this.scrollHeight > 295) {
        let scrolleHeightMargin = 110;
        if (!this.displayPaginator)
          scrolleHeightMargin = 106;
        this.ScrollableHeight = this.scrollHeight - scrolleHeightMargin + this.scrollHeightOffset + "px"; //242 <=> button + header + page selection
      }
    }
    else {
      this.objectListSelection = [];
      this.initialiseDatas();
    }
    if (this.table != null && changes['preSelection'] == undefined)
      this.table.scrollTo({ top: 0, behavior: 'smooth' });

    if (changes['objectList'] != null && this.table != null && this.objectList != undefined && this.table.rows) {
      this.numbersPages = Math.ceil(this.objectList.length / this.table.rows);
      this.lastItem = this.table.rows * this.currentPage;
      if (this.lastItem > this.objectList.length) this.lastItem = this.objectList.length;
      this.convertDateStringInDate();
      this.lastRowsBeforeUpdate = [];
    }
    if (changes['loading'] && changes['loading'].currentValue == false) {
      this.tools.delay(200).then((res) => {
        if (this.table) {
          this.table.totalRecords = this.objectList?.length;
          this.setPage(1);
          if (this.fullWidth != -1) {
            if (this.arrayContainer?.nativeElement.scrollWidth < this.fullWidth) this.table.setResizeTableWidth(this.fullWidth + 'px');
          }
        } else {
          LogService.logContext(this);
        }
      });
    }

    if (changes['columnsDefinition'] && changes['columnsDefinition'].currentValue) {
      if (!this.primeNgArrayD4Service.colsContainUnallowKeyWord(this.columnsDefinition)) this.initialiseColumns();
      else this.alertService.warn('nom de colonne du tableau invalide');
    }
    if (changes['goToBottom'] && changes['goToBottom'].currentValue == true) {
      this.goToBottom = false;
      if (this.table) this.table.scrollTo({ top: 55 * this.objectList.length });
      else {
        LogService.logContext(this);
      }
      // this.table.scrollTo({ bottom: 0}); //does not work on version primeng V13.3
    }
    this.changeDetectorRef.detectChanges();
  }

  ngAfterViewInit() {
    let path = window.location.pathname;
    if (path.length > 1)
      this.arrayName = path.substring(1) + "-" + this.arrayName;

    if (this.columnsDefinition != null) {
      //call alert in col name inside keyWordArray
      if (!this.primeNgArrayD4Service.colsContainUnallowKeyWord(this.columnsDefinition))
        this.initialiseColumns();
      else
        this.alertService.warn("nom de colonne du tableau invalide");
    }

    this.ActionOnSort();
    this.paginator();
    this.actionOnFilter();

    if (this.table)
      this.table.onPage.subscribe((itemPerPage) => {
        if (this.table?.rows) this.numbersPages = Math.ceil(this.table.totalRecords / this.table.rows);
        else {
          LogService.logContext(this);
        }
      });
    else {
      LogService.logContext(this);
    }

    let tableElement: any = document.getElementsByClassName("table-d4");
    for (let i = 0; i < tableElement.length; i++) {
      tableElement[i].firstChild.style.width = "100%";
      tableElement[i].firstChild.style.display = "grid";
    }
    let pDatatableScrollableBody: any = document.getElementsByClassName("p-datatable-scrollable-body");
    for (let i = 0; i < pDatatableScrollableBody.length; i++) {
      pDatatableScrollableBody[i].addEventListener("scroll", function (event: any) {
        let elem = document.getElementById('edit-table-body-container');
        if (elem != null) elem.scrollTop = event.target.scrollTop;
      });
    }

    if (this.table?.containerViewChild) {
      this.table.containerViewChild.nativeElement.onmouseenter = () => {
        this.pointerInsideArrayDiv = true;
      };
      this.table.containerViewChild.nativeElement.onmouseleave = () => {
        this.pointerInsideArrayDiv = false;
      };
    } else {
      LogService.logContext(this);
    }

    if (!this.displayPaginator) {
      const element: any = document.getElementsByTagName("p-paginator")[0];
      if (element?.style != null)
        element.style.display = "none";
    }

    //set size manually, bug fix for very with table (with scroll bar)
    this.fullWidthCalculation()
    this.changeDetectorRef.detectChanges();

  }

  private initialiseDatas() {
    if (this.heightMode == "full") {
      this.styleClass = "p-datatable-content p-datatable-sm"
      this.styleClassPaginator = "paginator-full-height-array"
    }
    else {
      this.styleClass = "p-datatable-content p-datatable-sm p-datatable-content-variable-height"
      this.styleClassPaginator = "paginator-variable-height-array"
    }

    let scrolleHeightMargin = 202;
    if (this.objectList != null && this.objectList.error != null) {
      this.numbersPages = 1;
      this.objectList = [];
      return;
    }

    if (!this.displayPaginator) {
      this.defaultRows = 99999;
      this.rowsPerPageOptions = null;
      this.currentPageReportTemplate = "";
      scrolleHeightMargin = 128;
    }

    if (this.scrollHeight == null || this.scrollHeight == 0)
      this.ScrollableHeight = window.innerHeight - scrolleHeightMargin + this.scrollHeightOffset + "px";

    window.addEventListener('resize', (event) => {
      this.ScrollableHeight = window.innerHeight - scrolleHeightMargin + this.scrollHeightOffset + 'px';
    });

    if (this.objectList != null && this.objectList.length > 0 && this.table && this.table.rows) {
      this.convertDateStringInDate();
      this.objectList.forEach((object: any) => {
        object['show'] = false;
      });
      this.numbersPages = Math.ceil(this.objectList.length / this.table.rows);
    }

    if (this.preSelection != null) {
      this.preSelection.forEach(item => { if (item != null) { item["show"] = false; } });
      this.objectListSelection = JSON.parse(JSON.stringify(this.preSelection));
    }
  }

  private initialiseColumns() {
    let hasLocalisationColumn: boolean = false
    this.columnsDefinitionRef = [];
    this.columnsDefinition.forEach(columnDefinition => {
      let configurationDefinition =
      {
        name: columnDefinition.name,
        ngStyle: JSON.parse(JSON.stringify(columnDefinition.ngStyle)),
      };
      if (columnDefinition.type == "geolocalisation") {
        if (!window.document.getElementById('google-map-script')) {
          //appen gmaps script ONE time if cmp has been call   AIzaSyB3h_FbHpWi8unmJcMv9R__9l-8VjJVae8
          var s = window.document.createElement("script");
          s.id = "google-map-script";
          s.type = "text/javascript";
          s.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyB3h_FbHpWi8unmJcMv9R__9l-8VjJVae8";
          s.async = true;
          window.document.body.appendChild(s);
        }
      }
      this.columnsDefinitionRef.push(configurationDefinition);
    });

    this.columnsDefinition.forEach(columnDefinition => {
      this.primeNgCols.push({ field: columnDefinition.name, header: columnDefinition.displayName });
    });
    this.columnsDefinition = this.primeNgArrayD4Service.getLocalUserWidthDefinition(this.columnsDefinition, this.arrayName);
  }

  public openSummary(objectSelected: any) {
    let jsonSummary = {}
    let data: any = {}
    let columnDefinitionMatching: any = this.columnsDefinition.find(column => { return column.type == 'summary' })
    if (objectSelected.id != "") {
      this.getJsonService.getJson(encodeURI(environment.apiFlowConfig.apiUrlMd + "summaries/" + objectSelected.id + "/d7c243aef496499898dea0b1399b3197"), undefined, { t: encodeURI(objectSelected.typeFullName) }, true).pipe(
        first()).subscribe(
          summaryGetResult => {
            if (summaryGetResult.error == undefined) {
              jsonSummary = summaryGetResult?.jsonSummary;
              data["jsonSummary"] = jsonSummary
              data["error"] = ""
              data["entityDefinition"] = columnDefinitionMatching["datas"]["entityDefinition"]
              data["summaryTitle"] = columnDefinitionMatching["datas"]["summaryTitle"]

              data["eventType"] = {}; data["eventType"]["modalMode"] = "floatting"
            }
            const ref = this.overlayService.open(EntitySummaryOverlayContainerComponent, data, { styleDefinition: { 'border-radius': '8px', width: '700px' } }, false);
            ref.afterClosed$.subscribe(
              result => {
                console.log(result);
              });
          });
    }
  }

  public getObject(colName: string, object: any): any {
    let val: any;
    if (object == null)
      return;
    if (colName.includes("."))
      val = lodhash.get(object, colName);
    else
      val = object[colName];
    if (val == undefined)
      val = "";
    return val;
  }

  public getObjectToolTip(colName: any, ri: number) {
    let val: any;
    if (colName.includes('.')) val = lodhash.get(this.objectHelperList[ri], colName);
    else val = this.objectHelperList[ri][colName];
    if (val == undefined) val = '';
    return val;
  }


  public copyField(colName: string, object: any, format: any): any {
    let val: any;
    if (colName.includes("."))
      val = lodhash.get(object, colName);
    else
      val = object[colName];
    if (val == undefined)
      val = "";
  }

  public getImgB64(colName: string, object: any): any {
    let valSanitize: any;
    let value: string;
    if (colName.includes("."))
      value = lodhash.get(object, colName);
    else
      value = object[colName];
    if (value == undefined) {
      value = "";
      valSanitize = "";
    }
    else {
      if (value.includes("data:image"))
        valSanitize = this.sanitizer.bypassSecurityTrustResourceUrl(value);
      else //default consider svg picture
        valSanitize = this.sanitizer.bypassSecurityTrustResourceUrl("data:image/svg+xml;base64," + value);
    }
    return valSanitize;
  }


  private setBottomPageNumber(event: any) {
    this.filterList = event;
    if (this.table?.rows && this.table?.first) {
      this.numbersPages = Math.ceil(this.table.totalRecords / this.table.rows);
      if (this.table.rows <= this.objectList.length) this.lastItem = this.table.rows * this.currentPage;
      else this.lastItem = this.objectList.length;
      if (this.lastItem > this.table.totalRecords) this.lastItem = this.table.totalRecords;
      this.currentPage = this.table.first / this.table.rows + 1;
      if (this.currentPage > this.numbersPages) this.currentPage = this.numbersPages;
    } else {
      LogService.logContext(this);
    }
  }

  public actionOnFilter() {
    if (this.table)
      this.table.onFilter.subscribe((event) => {
        this.setBottomPageNumber(event.filters);
      });
    else {
      LogService.logContext(this);
    }
  }

  public focusFilterInput(nodeHtml: any) {
    this.tools.delay(150).then((res) => {
      nodeHtml.focus();
    });
  }


  public paginator() {
    if (this.table)
      this.table.rowsChange.subscribe(() => {
        if (this.table?.first && this.table?.rows) this.currentPage = this.table.first / this.table.rows + 1;
        if (this.table?.rows && this.table.rows <= this.objectList.length) this.lastItem = this.table.rows * this.currentPage;
        else this.lastItem = this.objectList.length;
        if (this.table?.totalRecords && this.lastItem > this.table.totalRecords) this.lastItem = this.table.totalRecords;
        this.changeDetectorRef.detectChanges();
      });
    else {
      LogService.logContext(this);
    }
  }

  public ActionOnSort() {
    if (this.table)
      this.table.onSort.subscribe((sortObject) => {
        let sortingValuesN = sortObject.multisortmeta;
        //different size => new sort (on a different item) => store value abd return
        if (this.sortingValuesN1.length == sortingValuesN.length && this.sortingValuesN2.length != 0) {
          for (let i = 0; i < sortingValuesN.length; i++) {
            if (this.sortingValuesN1[i].field == sortingValuesN[i].field && this.sortingValuesN1[i].order != sortingValuesN[i].order) {
              //find same field in N-1, N-2, N
              let itemFindedInN2 = null;
              if (this.sortingValuesN1.length > this.sortingValuesN2.length) {
                for (let j = 0; j < this.sortingValuesN2.length; j++) {
                  if (
                    this.sortingValuesN2[j].field == this.sortingValuesN1[i].field &&
                    this.sortingValuesN1[i].field == sortingValuesN[i].field &&
                    this.sortingValuesN2[j].order != this.sortingValuesN1[j].order
                  ) {
                    itemFindedInN2 = this.sortingValuesN2[j];
                    break;
                  }
                }
              } else {
                for (let j = 0; j < this.sortingValuesN1.length; j++) {
                  if (
                    this.sortingValuesN2[j].field == this.sortingValuesN1[i].field &&
                    this.sortingValuesN1[i].field == sortingValuesN[i].field &&
                    this.sortingValuesN2[j].order != this.sortingValuesN1[j].order
                  ) {
                    itemFindedInN2 = this.sortingValuesN2[j];
                    break;
                  }
                }
              }
              if (itemFindedInN2 != null) {
                sortObject.multisortmeta.splice(i, 1);
              }
              break;
            }
          }
        }
        this.sortingValuesN2 = JSON.parse(JSON.stringify(this.sortingValuesN1));
        this.sortingValuesN1 = JSON.parse(JSON.stringify(sortingValuesN));
        this.changeDetectorRef.detectChanges();
      });
    else {
      LogService.logContext(this);
    }
  }
  private keyDownEventManager(event: KeyboardEvent | any, editFirstLine: boolean = false) {
    if (event.code == "F2") {
      if (this.pointerInsideArrayDiv && !editFirstLine) {
        let rowSelectedIndex = this.objectList.findIndex((object: any) => object.show === true);
        let element: HTMLElement = document.getElementById(("colIndex" + this.arrayGuid + (rowSelectedIndex).toString())) as HTMLElement;
        if (element != undefined || element != null) {
          element.click();
        }
      }
      else if (editFirstLine) {
        let element: HTMLElement = document.getElementById(("colIndex" + this.arrayGuid + (0).toString())) as HTMLElement;
        if (element != undefined || element != null) {
          element.click();
        }
      }
    }
  }

  public dragStart(event: any, row: any) {
    row["type"] = this.type
    this.sharedMenuServices.setPoolDragAndDrop(row)
    this.tools.delay(150).then(res => {
      this.sharedMenuServices.setDragAndDropMvt(true)
    })
  }

  public dragEnd(event: any) {
    //this.sharedMenuServices.setDragAndDropMvt(false)
  }

  public keyDownEventManagerRow(event: KeyboardEvent, row: any) {
    if (event.code == "Escape" && row != null && row.id != null) {
      let lastItem = this.lastRowsBeforeUpdate.find(lastRow => lastRow.id == row.id);
      if (lastItem != null) {
        let itemIndex = this.objectList.findIndex((item: any) => item.id === row.id);
        this.objectList[itemIndex] = lastItem;
        this.lastRowsBeforeUpdate.splice(lastItem, 1);
      }
    }
  }

  public setPage(page: number) {
    page = +page;
    if (page > this.numbersPages) page = this.numbersPages;
    if (Number.isInteger(page) == false) page = 1;
    if (this.table) {
      if (page == 0) {
        this.table.first = 0;
        this.currentPage;
      } else if (this.table.rows != undefined) {
        this.table.first = (page - 1) * this.table.rows;
        this.currentPage = page;
      }
      if (this.table.rows) this.lastItem = this.table.rows * this.currentPage;
      if (this.lastItem > this.table.totalRecords) this.lastItem = this.table.totalRecords;
    } else {
      LogService.logContext(this);
    }
    this.changeDetectorRef.detectChanges();
  }

  public handleMouseOver(row: any) {
    row.show = true;
  }

  public handleMouseLeave(row: any) {
    row.show = false;
  }

  public drop(event: any, object: any) {
    let columnDefinitionMatching = this.columnsDefinition.find(column => {
      if (column.drop != null && column.drop.dropType == this.itemDrag.type) {
        this.changeDetectorRef.detectChanges();
        return column.drop;
      }
      else
        return null;
    });
    if (columnDefinitionMatching != null) {
      if (this.itemDrag.id != null) {
        //find event
        let dataEdited = object;
        if (columnDefinitionMatching?.drop?.itemsToSet != undefined) {
          columnDefinitionMatching.drop.itemsToSet.forEach(item => {
            dataEdited[item.destination] = this.itemDrag[item.origin];
          });
          this.objectEdited = dataEdited;
          this.updateObjectOutput(true);
        }
      }
    }
    this.changeDetectorRef.detectChanges();
  }

  public dragEnter(event: any, ri: any) {
    this.dragRowOver = ri;
    this.changeDetectorRef.detectChanges();
  }


  public handleRowClick(event: any, row: any) {
    if (event?.srcElement?.innerText != undefined && typeof event.srcElement.innerText == "string" && !event.srcElement.innerText.includes("edit"))
      this.rowClick.emit(row);
  }

  public fixBouncingCLientRect() {
    let nodeOverlayPane = document.getElementsByClassName("cdk-overlay-pane");
    for (let i = 0; i < nodeOverlayPane.length; i++) {
      let node: any = nodeOverlayPane[i];
      node.style.top = node.offsetTop * 0.85 + "px";
      node.style.left = node.offsetLeft * 0.85 + "px";
    }
  }

  public editCellInit(object: any, event: any) {
    //disable click event on calendar header (mat-calendar-header)    
    if (event != null && event.target != null && event.target.select != null)
      event.target.select();

    let objectAsString = JSON.stringify(object);
    let obj = JSON.parse(objectAsString);
    if (this.lastRowsBeforeUpdate.length == 0)
      this.lastRowsBeforeUpdate.push(obj);

    else if (this.lastRowsBeforeUpdate[this.lastRowsBeforeUpdate.length - 1].id != object.id)
      this.lastRowsBeforeUpdate.push(obj);

    this.changeDetectorRef.detectChanges();
  }
  public editCellComplete(editEvent: any) {
    //find input type using field
    let columnEdited = this.columnsDefinition.find((columnDefinition) => columnDefinition.name == editEvent.field);
    if (columnEdited != undefined)
      switch (
      columnEdited.type // "checkBox" | "string" | "number" | "phone" | "currency" | "date" | "enum" | "decimal" | "edit" | "",
      ) {
        case 'date':
          if (editEvent?.originalEvent?.currentTarget?.ownerDocument?.activeElement?.value != null) {
            if (editEvent.originalEvent.currentTarget.ownerDocument.activeElement.value == '') {
              editEvent.data = lodhash.omit(editEvent.data, [editEvent.field]);
            } else {
              let srtDate: string = editEvent.originalEvent.currentTarget.ownerDocument.activeElement.value;
              let regex = new RegExp('^[0-9]*/[0-9]*/[0-9]*', 'g');
              if (regex.test(srtDate)) {
                //convert dd/mm/yyyy to date type
                var dateMomentObject = moment(srtDate, 'DD/MM/YYYY');
                var dateObject = dateMomentObject.toDate();
                lodhash.set(editEvent.data, editEvent.field, dateObject);
              } else lodhash.set(editEvent.data, editEvent.field, new Date(editEvent.originalEvent.currentTarget.ownerDocument.activeElement.value));
            }
          } else if (editEvent.dateGenerated != null)
            //eventGenerated from methode inputDateChange or inputDateChangeKeyBoardInput
            lodhash.set(editEvent.data, editEvent.field, editEvent.dateGenerated);
          break;
        case 'dateTime':
          if (editEvent?.originalEvent?.currentTarget?.ownerDocument?.activeElement?.value != null) {
            if (editEvent.originalEvent.currentTarget.ownerDocument.activeElement.value == '') {
              editEvent.data = lodhash.omit(editEvent.data, [editEvent.field]);
            } else {
              let srtDate: string = editEvent.originalEvent.currentTarget.ownerDocument.activeElement.value;
              let regex = new RegExp('^[0-9]*/[0-9]*/[0-9]*', 'g');
              if (regex.test(srtDate)) {
                //convert dd/mm/yyyy to date type
                var dateMomentObject = moment(srtDate, 'DD/MM/YYYY, HH:mm');
                var dateObject = dateMomentObject.toDate();
                lodhash.set(editEvent.data, editEvent.field, dateObject);
              } else lodhash.set(editEvent.data, editEvent.field, new Date(editEvent.originalEvent.currentTarget.ownerDocument.activeElement.value));
            }
          } else if (editEvent.dateGenerated != null)
            //eventGenerated from methode inputDateChange or inputDateChangeKeyBoardInput

            lodhash.set(editEvent.data, editEvent.field, editEvent.dateGenerated);
          break;
        case 'enum':
          //already done using methode setEnum
          break;
        case 'phone':
          //nothing to do event already update by setPhoneNumber() method
          break;
        case 'number':
          if (editEvent.originalEvent.target.value != null) lodhash.set(editEvent.data, editEvent.field, +editEvent.originalEvent.target.value);
          break;
        case 'decimal':
          if (editEvent.originalEvent.target.value != null) lodhash.set(editEvent.data, editEvent.field, +editEvent.originalEvent.target.value);
          break;
        case 'duration':
          console.log('duration', editEvent);
          break;
        case 'booleanCheckBox':
          console.log('event', editEvent);
          let value = false;
          if (+editEvent.data[editEvent.field].checked == 1 || editEvent.data[editEvent.field].checked == true) value = true;
          lodhash.set(editEvent.data, editEvent.field, value);
          let oldObj = JSON.parse(JSON.stringify(editEvent.data));
          oldObj[editEvent.field] = !oldObj[editEvent.field];
          if (this.lastRowsBeforeUpdate.length == 0) this.lastRowsBeforeUpdate.push(oldObj);
          else if (this.lastRowsBeforeUpdate[this.lastRowsBeforeUpdate.length - 1].id != editEvent.data.id) this.lastRowsBeforeUpdate.push(oldObj);
          break;
        case 'currency':
          lodhash.set(editEvent.data, editEvent.field, +editEvent.data[editEvent.field]);
          if (editEvent.originalEvent.type == 'keydown' && columnEdited.writeLine)
            this.writeLine(columnEdited.writeLine, editEvent.field, editEvent.data, editEvent.originalEvent.target);
          break;
        default: // "string" | "number" | "decimal"
          if (editEvent.originalEvent.target.value != null && columnEdited.writeLine)
            this.writeLine(columnEdited.writeLine, editEvent.field, editEvent.data, editEvent.originalEvent.target);
          break;
      }
    let dataEdited = editEvent.data;
    let field = editEvent.field;

    if (editEvent.originalEvent.code == 'Tab') {
      //find la editable col
      let lastColPosition = this.columnsDefinition.length - 1;
      for (let i = this.columnsDefinition.length - 1; i > 0; i--) {
        if (this.columnsDefinition[i].readOnly == false) {
          lastColPosition = i;
          break;
        }
      }

      if (this.lastRowsBeforeUpdate[this.lastRowsBeforeUpdate.length - 1].id != dataEdited.id) {
        this.objectEdited = dataEdited;
        this.updateObjectOutput(true);
      } else if (field == this.columnsDefinition[lastColPosition].name) {
        //last col
        this.objectEdited = dataEdited;
        this.updateObjectOutput(true);
      }
    } else if (
      editEvent.originalEvent.code == 'Enter' ||
      editEvent.originalEvent.code == 'NumpadEnter' ||
      editEvent.originalEvent.code == 'ArrowDown' ||
      editEvent.originalEvent.code == 'ArrowUp'
    ) {
      this.objectEdited = dataEdited;
      this.updateObjectOutput(true);
    } else if (editEvent.originalEvent.type == 'click') {
      this.objectEdited = dataEdited;
      if (this.lastRowsBeforeUpdate.length >= 1) {
        let lastIndex = this.objectList.findIndex((row: any) => row.id === this.lastRowsBeforeUpdate[this.lastRowsBeforeUpdate.length - 1].id);
        if (editEvent.originalEvent?.path != undefined && editEvent.originalEvent?.path[0]?.localName == 'p-celleditor') {
          if (
            editEvent.originalEvent.path[2] != null &&
            editEvent.originalEvent.path[2].rowIndex != null &&
            editEvent.originalEvent.path[2].rowIndex != lastIndex
          ) {
            this.objectEdited = dataEdited;
            this.updateObjectOutput(true);
          }
        } else if (editEvent.originalEvent?.path != undefined && editEvent.originalEvent?.path[0]?.localName == 'td') {
          if (
            editEvent.originalEvent.path[1] != null &&
            editEvent.originalEvent.path[1].rowIndex != null &&
            editEvent.originalEvent.path[1].rowIndex != lastIndex
          ) {
            this.objectEdited = dataEdited;
            this.updateObjectOutput(true);
          }
        } else {
          //click outside div
          this.objectEdited = dataEdited;
          this.updateObjectOutput(true);
        }
      }
    }
    this.changeDetectorRef.detectChanges();
  }
  public outputValue(field: string, object: any, event: any) {
    if (event != null) {
      lodhash.set(object, field, event);
      let eventToWrite = {
        data: object,
        originalEvent: { code: "Enter" },
        field: field,
      };
      this.editCellComplete(eventToWrite);
    }
    this.changeDetectorRef.detectChanges();
  }

  public inputChange(field: string, object: any, event: any) {
    if (event != null)
      lodhash.set(object, field, event.value);
    this.changeDetectorRef.detectChanges();
  }

  public inputDateChange(field: string, object: any, event: any) {
    if (event?.value?._i != null || event?.value?._d != null || event?.value != null) {
      let eventToWrite = {
        data: object,
        originalEvent: { code: "Enter" },
        field: field,
        dateGenerated: new Date(event.target.value)
      };
      this.editCellComplete(eventToWrite);
    }
    this.changeDetectorRef.detectChanges();
  }

  public inputDateChangeKeyBoardInput(field: string, object: any, event: any) {
    if (event?.target?.value != '') {
      let dateGenerated = new Date(event.target.value)
      /* fix input date time bug => error on new Date(event.target.value) if date id '01/02/2024' reuslt would be 2 january 2024*/
      moment.locale(this.locale);
      const localeData = moment.localeData();
      const format = localeData.longDateFormat('L');
      let momentDate = moment(event.target.value, format)
      if (momentDate != undefined)
        dateGenerated = momentDate.toDate()

      let eventToWrite = {
        originalEvent: { code: "Enter" },
        data: object,
        field: field,
        dateGenerated: dateGenerated
      };
      this.editCellComplete(eventToWrite);
    }
    this.changeDetectorRef.detectChanges();
  }

  public displayTextArea(columnName: string, object: any, rw: boolean) {
    let width: string = "750px";
    let height: string = "650px";

    const ref = this.overlayService.open(ModalTextAreaForArrayComponent,
      { texte: object[columnName], rw: rw },
      {
        styleDefinition: { 'border-radius': '8px', width: width, height: height, position: "fixed", top: "calc(50% - 325px)", "left": "calc(50% - 375px)" }
      });
    ref.afterClosed$.subscribe(
      result => {
        //editEvent.originalEvent.code
        if (result.data != undefined) {
          object[columnName] = result.data;
          let eventToWrite = {
            originalEvent: { code: "Enter", target: { value: result.data } },
            data: object,
            field: columnName,
          };
          this.editCellComplete(eventToWrite);
        }
      });
  }

  public setPhoneNumber(phoneFromCmp: any, field: string, object: any) {
    let phoneNumber = "";
    if (phoneFromCmp?.e164Number != undefined)
      phoneNumber = phoneFromCmp?.e164Number;
    else if (phoneFromCmp?.number != undefined)
      phoneNumber = phoneFromCmp?.number;
    lodhash.set(object, field, phoneNumber);
    console.log("setPhoneNumber object", object);
    this.changeDetectorRef.detectChanges();
  }

  public callmethode(methode: lineDisplay, object: any): any {
    return methode.methodImplementation(object);
  }

  public writeLine(method: writeMethod, field: string, object: any, event: any) {
    if (method != null) {
      method.methodImplementation(field, object, event.value);
    }
    else
      this.inputChange(field, object, event);
  }

  public showPopUp(popUpCmp: popUpComponent, object: any, event: any = undefined) {
    this.externalComponentService.showPopUp(popUpCmp, object, event).subscribe((result) => {
      if (result != null) this.editionOutput.emit(result);
    });
  }


  public editObject(event: any) {
    if (event.id != null) this.sidenavEdit.emit(event.id);
  }

  public objectAction(event: any, actionName: any) {
    if (event.id != null) {
      let outEvent = { id: event.id, actionName: actionName };
      this.itemAction.emit(outEvent);
    }
  }

  public updateObjectOutput(reload: boolean) {
    let compareItem1: any = JSON.parse(JSON.stringify(this.objectEdited));
    let compareItem2: any = '';
    if (this.lastRowsBeforeUpdate[this.lastRowsBeforeUpdate.length - 1] != null)
      compareItem2 = JSON.parse(JSON.stringify(this.lastRowsBeforeUpdate[this.lastRowsBeforeUpdate.length - 1]));
    delete compareItem1['show'];
    delete compareItem2['show'];
    if (JSON.stringify(compareItem1) === JSON.stringify(compareItem2)) {
      let indexToRemove = this.lastRowsBeforeUpdate.findIndex((row) => row.id == this.objectEdited.id);
      this.lastRowsBeforeUpdate.splice(indexToRemove, 1);
      return;
    } else {
      //parse dataEdited, if data type is date and value is '' force to null
      let objectToSend = JSON.parse(JSON.stringify(this.objectEdited));
      Object.keys(objectToSend).forEach((key) => {
        let typeFinded = this.columnsDefinition.find((column) => column.name === key);
        if (typeFinded != undefined && typeFinded.type == 'date' && objectToSend[key] == '') delete objectToSend[key];
      });
      delete objectToSend['show'];
      this.editionOutput.emit(objectToSend);
      this.editionOutputV2.emit({
        newValue: objectToSend,
        oldValue: this.lastRowsBeforeUpdate[this.lastRowsBeforeUpdate.length - 1],
      });
    }
  }

  public checkBoxSelected() {
    this.selection.emit(this.objectListSelection);
  }

  public columnsResized(event: any) {
    //current cell
    if (event?.delta) {
      if (this.columnsDefinition[event.element.cellIndex].ngStyle == '') this.columnsDefinition[event.element.cellIndex].ngStyle = {};
      this.columnsDefinition[event.element.cellIndex].ngStyle['flex.px'] =
        '0 0 ' + (+this.columnsDefinition[event.element.cellIndex].ngStyle['flex.px'].split(' ')[2] + event.delta).toString();
      //next cell
      if (this.columnResizeMode == 'fit') {
        if (this.columnsDefinition[event.element.cellIndex + 1].ngStyle == '') this.columnsDefinition[event.element.cellIndex + 1].ngStyle = {};
        this.columnsDefinition[event.element.cellIndex + 1].ngStyle['flex.px'] =
          '0 0 ' + (+this.columnsDefinition[event.element.cellIndex + 1].ngStyle['flex.px'].split(' ')[2] - event.delta).toString();
        this.primeNgArrayD4Service.setLocalUserWidthDefinition(this.columnsDefinition, this.arrayName);
      }
    }
    this.fullWidthCalculation();
  }

  public columnsReorder(event: any) {
    //move cell => update width on reorder
    let dragIndexNgStyle = this.columnsDefinition[event.dragIndex].ngStyle;
    let dropIndexNgStyle = this.columnsDefinition[event.dropIndex].ngStyle;
    this.columnsDefinition[event.dragIndex].ngStyle = dragIndexNgStyle;
    this.columnsDefinition[event.dropIndex].ngStyle = dropIndexNgStyle;
    this.primeNgArrayD4Service.setLocalUserWidthDefinition(event.columns, this.arrayName);
  }

  public resetLocalConfiguration() {
    this.primeNgArrayD4Service.resetLocalConfiguration(
      this.columnsDefinitionRef,
      this.columnsDefinition,
      this.changeDetectorRef,
      this.arrayName,
      this.table,
    );
  }

  public filter(event: any, colName: string | undefined) {
    let value = event.target.value;
    if (value == undefined) value = '';
    if (colName) this.table?.filter(value, colName, 'contains');
    else this.table?.filterGlobal(value, 'contains');
  }

  public resetFilters() {
    if (this.table) {
      Object.keys(this.table.filters).forEach((key) => {
        const filter = this.table?.filters[key];
        if (filter && !Array.isArray(filter) && filter.value != undefined) {
          if (!Array.isArray(filter)) {
            filter.value = '';
          }
        }
      });
      this.setBottomPageNumber({});
      this.table.clear();
      this.table.cd.detectChanges();
      this.changeDetectorRef.detectChanges();
    } else {
      LogService.logContext(this);
    }
  }

  private fullWidthCalculation() {
    //set size manually, bug fix for very with table (with scroll bar)
    let setFullWidth: boolean = true;
    let fullWidth: number = 0;

    if (this.table?.columns) {
      const columns: any[] = this.table?.columns;
      columns?.forEach((column) => {
        let widthFlex: any[] = column?.ngStyle['flex.px'].split(' ');
        if (widthFlex.length == 3) {
          fullWidth += +widthFlex[2];
        } else setFullWidth = false;
      });
      if (setFullWidth) this.fullWidth = fullWidth;
    } else {
      LogService.logContext(this);
    }
  }

  private convertDateStringInDate() {
    this.objectList.forEach((object: any) => {
      if (this.columnsDefinition != undefined)
        this.columnsDefinition.forEach((column) => {
          if (object[column.name] != null && object[column.name] != '' && (column.type == 'date' || column.type == 'dateTime')) {
            if (column.type == 'date') object[column.name] = this.tools.getIsoDate(new Date(object[column.name]));
            else object[column.name] = new Date(object[column.name]);
          }
        });
    });
  }

  public downloadLink(objectSelected: any, columnDefinitionName: any, event: any) {
    this.externalComponentService.downloadLink(objectSelected, columnDefinitionName, event);
  }

  public mailLink(objectSelected: any, columnDefinitionName: any, event: any) {
    this.externalComponentService.mailLink(objectSelected, columnDefinitionName, event);
  }

  public phoneLink(objectSelected: any, columnDefinitionName: any, event: any) {
    this.externalComponentService.phoneLink(objectSelected, columnDefinitionName, event);
  }

  public openLocation(objectSelected: any, columnDefinitionName: any, event: any) {
    this.externalComponentService.openLocation(objectSelected, columnDefinitionName, event);
  }

  public clipBoardContentInfo() {
    this.alertService.success("Contenu copié");
  }
}

export interface columnDefinition {
  type:
  | 'checkBox'
  | 'string'
  | 'textArea'
  | 'number'
  | 'phone'
  | 'currency'
  | 'date'
  | 'enum'
  | 'decimal'
  | 'edit'
  | 'dateTime'
  | 'icon'
  | 'imgB64'
  | 'booleanCheckBox'
  | 'duration'
  | 'booleanDropDown'
  | 'link'
  | 'geolocalisation'
  | 'mail'
  | 'summary'
  | '';
  readOnly: boolean;
  name: string;
  displayName: string;
  ngStyle: any; //see https://angular.io/api/common/NgStyle
  enum: { value: any; displayValue: string }[] | null;
  drop: {
    dropName: string;
    dropType: string;
    itemsToSet?: { origin: string; destination: string }[];
  } | null;
  localFilter: boolean | null;
  help?: string;
  copyBtn?: boolean;
  helpValue?: boolean;
  printLine?: lineDisplay;
  writeLine?: writeMethod;
  popUpComponent?: popUpComponent;
  datas?: any;
}

export interface lineDisplay {
  methodImplementation: (...args: any[]) => twoLinesDisplay;
}

export interface writeMethod {
  methodImplementation: (field: string, object: any, event: any) => any;
}

export interface popUpComponent {
  component: string | TemplateRef<any> | Type<any>,
  data: any;
  styleDefinition?: any;
}

export interface twoLinesDisplay {
  topLine: string,
  bottomLine: string,
}
